import { writable } from 'svelte/store';

export const statsStore = writable(0);
